import AxiosApi from "@/config/axios";

const BankSlipService = {};

BankSlipService.getBankSlips = (page) => {
    return AxiosApi({
        url: `/bank-slips?page=${page}`,
        method: 'get',
    })
}

BankSlipService.getLatestBankSlipPaid = () => {
    return AxiosApi({
        url: `/bank-slips/last-paid`,
        method: 'get',
    })
}


export default BankSlipService;